import type { FC } from "react";
import { AdvisorAssistantsSection } from "web_myplann/Advisor/Components/AdvisorAssistantsSection";
import { AdvisorCard } from "web_myplann/Advisor/Components/AdvisorCard";
import { AdvisorCardSkeleton } from "web_myplann/Advisor/Components/AdvisorCardSkeleton";
import { mapAdvisorCardProps } from "web_myplann/Advisor/Mappers/mapAdvisorCardProps";
import type {
	AgentAssignedListItemResponseDTO,
	AgentDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MissingAdvisor } from "web_myplann/Profile/Components/MissingAdvisor";
import { LoadErrorWithRetry } from "web_myplann/Shared/Components/LoadErrorWithRetry";

type Props = {
	isLoading: boolean;
	isError: boolean;
	isRetrying: boolean;
	onRetry: () => void;
	selected?: AgentAssignedListItemResponseDTO;
	detail?: AgentDetailResponseDTO | null;
};

export const AdvisorPageBody: FC<Props> = ({
	isLoading,
	isError,
	isRetrying,
	onRetry,
	selected,
	detail,
}) => {
	const { t } = useResource();
	const isLoaded = !isLoading && !isError;

	return (
		<>
			{isLoading && <AdvisorCardSkeleton />}
			{!isLoading && isError && (
				<LoadErrorWithRetry
					title={t(Resources.Advisor.loadError.title)}
					description={t(Resources.Advisor.loadError.description)}
					retryLabel={t(Resources.Advisor.loadError.retry)}
					isRetrying={isRetrying}
					onRetry={onRetry}
				/>
			)}
			{isLoaded && (!selected || !detail) && <MissingAdvisor />}
			{isLoaded && !!selected && !!detail && (
				<>
					<AdvisorCard key={detail.uid} {...mapAdvisorCardProps(detail)} />
					{detail.assistants?.length > 0 && (
						<AdvisorAssistantsSection
							advisorUid={detail.uid}
							assistants={detail.assistants}
						/>
					)}
				</>
			)}
		</>
	);
};
